/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Payments_Title8Inputs */

const en_svc_messaging_bots_payments_title8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments and CRM hooks`)
};

const ar_svc_messaging_bots_payments_title8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدفوعات وربط CRM`)
};

const bn_svc_messaging_bots_payments_title8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পেমেন্ট ও CRM সংযোগ`)
};

const de_svc_messaging_bots_payments_title8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungen und CRM-Anbindungen`)
};

const es_svc_messaging_bots_payments_title8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagos e integraciones con CRM`)
};

const fr_svc_messaging_bots_payments_title8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiements et branchements CRM`)
};

const pt_svc_messaging_bots_payments_title8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamentos e ligações ao CRM`)
};

const zh_svc_messaging_bots_payments_title8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付与 CRM 对接`)
};

const tr_svc_messaging_bots_payments_title8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödemeler ve CRM bağlantıları`)
};

const ru_svc_messaging_bots_payments_title8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платежи и связки с CRM`)
};

const pl_svc_messaging_bots_payments_title8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatności i spięcia z CRM`)
};

/**
* | output |
* | --- |
* | "Payments and CRM hooks" |
*
* @param {Svc_Messaging_Bots_Payments_Title8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_payments_title8 = /** @type {((inputs?: Svc_Messaging_Bots_Payments_Title8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Payments_Title8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_payments_title8(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_payments_title8(inputs)
	if (locale === "de") return de_svc_messaging_bots_payments_title8(inputs)
	if (locale === "es") return es_svc_messaging_bots_payments_title8(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_payments_title8(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_payments_title8(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_payments_title8(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_payments_title8(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_payments_title8(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_payments_title8(inputs)
	return en_svc_messaging_bots_payments_title8(inputs)
});
export { svc_messaging_bots_payments_title8 as "svc_messaging-bots_PAYMENTS_title" }